module.exports = __webpack_public_path__ + "img/fr-20r.c8eefee8.svg";